import { render, staticRenderFns } from "./LayerMobile.vue?vue&type=template&id=24489b0c&scoped=true&name=layer-mobile&"
import script from "./LayerMobile.vue?vue&type=script&lang=js&"
export * from "./LayerMobile.vue?vue&type=script&lang=js&"
import style0 from "./LayerMobile.vue?vue&type=style&index=0&id=24489b0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24489b0c",
  null
  
)

/* custom blocks */
import block0 from "./LayerMobile.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports